import moment from 'moment';

const format = 'YYYY-MM-DD';

const normalizeDates = data => {
  const dates = {};
  if (!Array.isArray(data)) return dates;
  data.forEach(d => {
    const key = moment.utc(d.Timestamp).format(format);
    dates[key] = { ...d, key };
  });
  return dates;
};

// Data densification for dates.
// Fills in the missing dates
export const fillMissingDates = data => {
  const end_time = moment();
  const start_time = moment().subtract(1, 'months');
  const month_span = end_time.diff(start_time, 'days');
  const dates = [];
  const normData = normalizeDates(data);
  for (let i = 0; i < month_span + 1; i++) {
    const date = moment().subtract(i, 'days');
    const dateString = date.format(format);
    dates.push({
      date: new Date(date),
      dateString: date.format(format),
      Sum: 0,
      ...normData[dateString],
    });
  }
  return dates.reverse();
};

export const getStartAndEndTime = () => {
  const datetimeFormat = 'YYYY-MM-DDTHH:mm:ssZ';

  const end_time = moment().format(datetimeFormat);
  const start_time = moment()
    .subtract(1, 'months')
    .startOf('day')
    .format(datetimeFormat);

  return {
    start_time,
    end_time,
  };
};

export const currentTimeString = () => {
  const datetimeFormat = 'YYYY-MM-DD THH:mm:ssZ';

  return moment().format(datetimeFormat);
}

export const copyToClipboard = str => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};
